"use client"
import { useLocation } from 'react-router-dom';
// import Image from "next/image"
import { UserCog, Bell, Lock, Shield, Zap, Award, Menu } from "lucide-react"
import { Button } from "src/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader } from "src/components/ui/card"
import { useState, useEffect } from "react"

export default function Dashboard({ onMenuClick }) {
    const [appName, setAppName] = useState("App_name")
    // const [logoUrl, setLogoUrl] = useState("/images/coolriots-logo.png")
    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };
    const [isLoading, setIsLoading] = useState(true)
    const fetchApplicationKeyValue = async (tenantId, appId, keyPath) => {
        const url = `https://dev-bex.coolriots.ai/bexo/api/v2/applications/list_by_id/${tenantId}/${appId}`;

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const data = await response.json();
            const value = getNestedValue(data, keyPath);

            if (value !== undefined) {
                return value;
            } else {
                console.warn(`Key path "${keyPath}" not found in response.`);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    };
    // Simulate fetching app name based on user login
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const org = params.get('org');
    const appid = params.get('app');
    useEffect(() => {
        // setTenantId(org || ""); // Dynamically set tenant ID based on org
        fetchApplicationKeyValue(
            org, appid,
            'full_name'
        ).then(value => {
            console.log('Full Name:', value); // Output: ""
            setAppName(value)

        });
        // fetchApplicationKeyValue(
        //   org, appid,
        //   'settings'
        // ).then(value => {
        //   console.log('Full Name:', value.app_logo); // Output: ""
        //   setImgName(value.app_logo)

        // });
    }, [org]);

    // Simulate fetching logo from API
    useEffect(() => {
        const fetchLogo = async () => {
            try {
                setIsLoading(true)
                // Simulate API call delay
                await new Promise((resolve) => setTimeout(resolve, 800))

                // This would be the data from your API
                const response = {
                    logoUrl: "/images/coolriots-logo.png",
                }

                // setLogoUrl(response.logoUrl)
            } catch (error) {
                console.error("Failed to fetch logo", error)
                // Fallback to default logo on error
                // setLogoUrl("/images/coolriots-logo.png")
            } finally {
                setIsLoading(false)
            }
        }

        fetchLogo()
    }, [])

    return (
        <div className="flex flex-col flex-1 bg-gray-50">
            {/* Header */}
            {/* <header className="sticky top-0 z-50 w-full border-b bg-white">
                <div className="container flex h-16 items-center justify-between">
                    <div className="flex items-center gap-2">
                        {isLoading ? (
                            <div className="w-[150px] h-[40px] bg-gray-200 animate-pulse rounded"></div>
                        ) : (
                            // <Image
                            //     src={logoUrl || "/placeholder.svg"}
                            //     alt="Company Logo"
                            //     width={150}
                            //     height={40}
                            //     className="h-auto"
                            //     priority
                            // />
                            <h1>IMG</h1>
                        )}
                    </div>

                    <div className="flex items-center gap-2">
                        <Button className="bg-[#b10a2b] hover:bg-[#8e0823] text-white" size="sm">
                            Logout
                        </Button>
                        <Button variant="ghost" size="icon" className="md:hidden" onClick={onMenuClick}>
                            <Menu className="h-5 w-5" />
                            <span className="sr-only">Toggle menu</span>
                        </Button>
                    </div>
                </div>
            </header> */}

            {/* Content */}
            <main className="p-6 md:p-10">
                <div className="max-w-6xl mx-auto">
                    {/* Hero section with added top padding */}
                    <div className="text-center mb-12 p-4 pt-16">
                        <h1 className="text-3xl md:text-4xl font-bold mb-4">Welcome to the {appName} Platform</h1>
                        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                            your all-in-one solution for effortless innovation and seamless experiences.
                        </p>
                    </div>

                    {/* Feature cards */}
                    <div className="grid md:grid-cols-3 gap-6 mb-16">
                        <Card className="shadow-sm">
                            <CardHeader className="pb-2">
                                <div className="flex items-center">
                                    <UserCog className="h-6 w-6 mr-2" />
                                    <h2 className="text-xl font-semibold">Update Profile</h2>
                                </div>
                                <p className="text-sm text-gray-500">Manage your account information</p>
                            </CardHeader>
                            <CardContent>
                                <p className="text-gray-700">
                                    Keep your information current and secure. Easily update your personal details, preferences, and
                                    settings anytime.
                                </p>
                            </CardContent>
                            <CardFooter>
                                <Button variant="default">
                                    Edit Profile <span className="ml-2">→</span>
                                </Button>
                            </CardFooter>
                        </Card>

                        <Card className="shadow-sm">
                            <CardHeader className="pb-2">
                                <div className="flex items-center">
                                    <Bell className="h-6 w-6 mr-2" />
                                    <h2 className="text-xl font-semibold">Notifications</h2>
                                </div>
                                <p className="text-sm text-gray-500">Stay informed and up-to-date</p>
                            </CardHeader>
                            <CardContent>
                                <p className="text-gray-700">
                                    Control what alerts you receive and how. Customize your notification preferences to focus on what
                                    matters to you.
                                </p>
                            </CardContent>
                            <CardFooter>
                                <Button variant="default">
                                    Manage Alerts <span className="ml-2">→</span>
                                </Button>
                            </CardFooter>
                        </Card>

                        <Card className="shadow-sm">
                            <CardHeader className="pb-2">
                                <div className="flex items-center">
                                    <Lock className="h-6 w-6 mr-2" />
                                    <h2 className="text-xl font-semibold">Security Settings</h2>
                                </div>
                                <p className="text-sm text-gray-500">Protect your account</p>
                            </CardHeader>
                            <CardContent>
                                <p className="text-gray-700">
                                    Enhance your account security with password updates, two-factor authentication, and login history
                                    review.
                                </p>
                            </CardContent>
                            <CardFooter>
                                <Button variant="default">
                                    Review Security <span className="ml-2">→</span>
                                </Button>
                            </CardFooter>
                        </Card>
                    </div>

                    {/* Why choose section */}
                    <div className="mb-16">
                        <h2 className="text-2xl font-bold text-center mb-10">Why Choose Our Platform?</h2>
                        <div className="grid md:grid-cols-3 gap-8">
                            <div className="text-center">
                                <div className="flex justify-center mb-4">
                                    <Shield className="h-12 w-12 text-gray-700" />
                                </div>
                                <h3 className="text-xl font-semibold mb-2">Reliable & Secure</h3>
                                <p className="text-gray-600">
                                    Built with the latest technology to keep your data safe and ensure the app is always available when
                                    you need it
                                </p>
                            </div>

                            <div className="text-center">
                                <div className="flex justify-center mb-4">
                                    <Zap className="h-12 w-12 text-gray-700" />
                                </div>
                                <h3 className="text-xl font-semibold mb-2">Fast & Efficient</h3>
                                <p className="text-gray-600">
                                    Designed for speed and performance to help you complete tasks quickly without any delays
                                </p>
                            </div>

                            <div className="text-center">
                                <div className="flex justify-center mb-4">
                                    <Award className="h-12 w-12 text-gray-700" />
                                </div>
                                <h3 className="text-xl font-semibold mb-2">Great Value</h3>
                                <p className="text-gray-600">
                                    Get more features at a better price than competitors, with regular updates and improvements
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}
